import React, { useEffect, useState } from "react";
import { Alert, Col, Row, Spin } from "antd";
import { Link, useParams } from "react-router-dom";
import { css, styled } from "styled-components";

import StyledButton from "components/button/Button";
import History from "../components/History";
import { MobileContainer, StyledElement } from "../components/reusables";
import MainLayout from "layouts/MainLayout/MainLayout";
import CitizenProfile from "../components/CitizenProfile";
import { CitizenDetailHeader } from "../components/citizenDetailHeader";
import ProgramInfo from "./ProgramInfo";

import { useCitizenContext } from "../Context";
import { ENTITIES } from "constant/entity";
import { desktop } from "utils/styles";

import { useQrScannerContext } from "pages/QRScan/Context";
import { getIsAkapOrMaipProgram } from "utils/citizen";
import Eligible from "../components/Eligible";

const Container = styled(StyledElement)`
  background-image: none;
  padding-top: 0;
`;
const StyledCitizenDetailHeader = styled(CitizenDetailHeader)`
  ${desktop`
    display: none;

    > * {
      display: none;
    }
  `}
`;
const StyledMobileContainer = styled(MobileContainer)`
  position: relative;
  z-index: 1;
`;
const BackButton = styled(StyledButton)`
  height: 43px;
  border-radius: 11px;
  background: rgba(217, 217, 217, 0.21);
  min-width: 108px;
  span {
    color: initial;
  }
  @media only screen and (min-width: 768px) {
    background: white;
    span {
      color: initial;
    }
  }
`;
const RedeemButton = styled(StyledButton)`
  height: 43px;
  @media only screen and (min-width: 768px) {
    background: transparent !important;
  }

  ${({ theme }) => {
    const { entity, colors } = theme;
    let color = colors.primary;
    let hoverColor = colors.primaryHover;

    if ([ENTITIES.BPSF, ENTITIES.KAPMADUOLAN].includes(entity)) {
      color = colors.secondary;
      hoverColor = colors.secondaryHover;
    }

    return css`
      background-color: ${color};
      border-color: ${color};

      &:hover,
      &:focus {
        background-color: ${hoverColor};
        border-color: ${hoverColor};
      }

      &:disabled {
        background-color: transparent !important;
        span {
          color: black;
        }
      }
    `;
  }};
`;

const CitizenDetail = () => {
  const { citizen, canRedeem, isLoading } = useCitizenContext();
  const { user: agencyUser } = useQrScannerContext();

  return (
    <Container>
      <StyledCitizenDetailHeader />
      <StyledMobileContainer>
        <MainLayout>
          {isLoading ? <Spin /> : null}
          {!isLoading && !citizen ? (
            <Row gap={15}>
           <Col span={24}>
             <Alert message={"Error"} showIcon type="error" description={"Having trouble loading citizen data"} />
           </Col>
           <Col span={24} justify={"center"}>
             <Link to={-1}>
               <BackButton>Back</BackButton>
             </Link>
           </Col>
         </Row>
          ) : null}
          {citizen && !isLoading ? (
            <div>
              <CitizenProfile {...citizen} />
              {!getIsAkapOrMaipProgram(agencyUser.overrides?.citizen_program?.program?.id) ? (
                <Eligible />
              ) : (
                <>
                  <ProgramInfo />
                  <Row gutter={15} justify="center">
                    <Col>
                      <Link to={`/citizen/${citizen.id}/redeem`}>
                        <RedeemButton disabled={!canRedeem}> Redeem Social Service</RedeemButton>
                      </Link>
                    </Col>
                    <Col>
                      <Link to={-1}>
                        <BackButton>Back</BackButton>
                      </Link>
                    </Col>
                  </Row>
                  {citizen ? <History /> : null}
                </>
              )}
            </div>
          ) : null}
        </MainLayout>
      </StyledMobileContainer>
    </Container>
  );
};

export default CitizenDetail;
